import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../images/logo-primary.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "on-going-program-action" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "button-group" }

import { DialogBtn } from '@/components/dialog.vue';
  import { ColorVariants } from '@/constants';

  interface IProps {
    visible?: boolean;
    content?: string;
    btns?: DialogBtn[];
    btnStyle?: ColorVariants;
  }
  interface IEmits {
    (event: 'update:visible', visible: boolean): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    content: null,
    btns: null,
    btnStyle: null
  },
  emits: ["update:visible"],
  setup(__props: any) {

  
  


return (_ctx: any,_cache: any) => {
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.content), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.btns, (btn, index) => {
          return (_openBlock(), _createBlock(_component_AppLoadingButton, {
            key: index,
            class: "btn",
            pill: "",
            variant: btn.style,
            disabled: btn.disabled,
            loading: btn.loading,
            onClick: ($event: any) => (btn.click && btn.click())
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(btn.text), 1)
            ]),
            _: 2
          }, 1032, ["variant", "disabled", "loading", "onClick"]))
        }), 128))
      ])
    ], 512), [
      [_vShow, __props.visible]
    ])
  ]))
}
}

})